import { ErrorState, ID } from 'types';

interface ErrorStateParams {
  col: number;
  prev: ErrorState<ID>;
  row: ID;
}

export const addErrorState = ({ prev, row, col }: ErrorStateParams): ErrorState<ID> => {
  const error = { ...prev };

  if (!error[row]) {
    error[row] = [];
  }

  if (!error[row].includes(col)) {
    error[row].push(col);
  }

  return error;
};

export const removeErrorState = ({ prev, row, col }: ErrorStateParams): ErrorState<ID> => {
  const error = { ...prev };

  if (!error[row]) {
    return error;
  }
  error[row] = error[row].filter((column: number): boolean => column !== col);

  if (error[row].length === 0) {
    delete error[row];
  }
  return error;
};

/**
 * Removes all errors for a specific row and shifts subsequent row indices down.
 * Used when a line item (row) is deleted from a table.
 *
 * @param prev - The current error state
 * @param deletedRow - The row index that was deleted
 * @returns A new ErrorState with the deleted row removed and subsequent rows shifted
 */
export const removeRowErrors = (prev: ErrorState, deletedRow: number): ErrorState => {
  const newError: ErrorState = {};

  Object.keys(prev).forEach((rowKey: string): void => {
    const row = Number(rowKey);
    const columns = prev[row];

    if (row < deletedRow) {
      // Keep rows before the deleted row as-is
      newError[row] = [...columns];
    } else if (row > deletedRow) {
      // Shift rows after the deleted row down by 1
      newError[row - 1] = [...columns];
    }
    // Skip the deleted row - it's being removed
  });

  return newError;
};
